import swal from 'sweetalert'

export default {
  name: 'list',
  components: {},
  props: [],
  data () {
    return {
      libraries: {},
      errors: {},
      item: {},
      btn_submit: false

    }
  },
  computed: {
    data() {
      return this.$store.getters['Library/getListLibrary']
    }
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Library/getListLibrary', {})
    ]).then(res =>{
      this.$loading.complete()
    }).catch(errors => {
      console.log(errors)
      this.$loading.fail()
    })
  },
  methods: {

    detailImage (item){
      this.item = item
      this.$refs.DetailImage.show()
    },

    scTrash(){
      this.$router.push('trash')
    },

    destroy(){
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.btn_submit = true
            this.$loading.start()
            this.$store.dispatch('Library/destroy', {
              id: this.item.id
            }).then((res) => {
              this.$notify({
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$refs.DetailImage.hide()
              this.item ={}
              this.btn_submit = false
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/library/list/list.js